<textarea :value="modelValue" @input="updateInput" :placeholder="placeholder" autocomplete="" :id="name" rows="7"></textarea>